import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard");
  }, [user, loading, navigate]);

  const login = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    const authUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    // Google blocks OAuth inside iframes (e.g. the preview). Break out to the top window.
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = authUrl;
        return;
      }
    } catch (e) {
      console.warn("Cannot access window.top (cross-origin); using current window for OAuth", e);
    }
    window.location.href = authUrl;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2" data-testid="admin-login-page">
      <div className="hidden md:block relative overflow-hidden">
        <img src="/gallery/placeholder.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-matte/50" />
        <div className="relative z-10 h-full flex flex-col justify-end p-14">
          <img src="/brainwaves-mark.png" alt="Brainwaves" className="h-20 w-auto object-contain mb-6" />
          <p className="font-serif text-4xl text-ivory font-light leading-tight max-w-sm">An immersive art gallery &amp; creative learning space</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-10 bg-ivory">
        <div className="max-w-sm w-full">
          <p className="text-[11px] uppercase tracking-editorial text-plum mb-4">Studio Admin</p>
          <h1 className="font-serif text-4xl font-light mb-6">Welcome back.</h1>
          <p className="text-matte/60 leading-relaxed mb-10">
            Sign in with Google to manage artwork, products, programs, orders, and enrollments.
          </p>
          <button
            onClick={login}
            data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 border border-matte py-4 text-[12px] uppercase tracking-editorial hover:bg-matte hover:text-ivory transition-colors duration-300"
          >
            Continue with Google
          </button>
        </div>
      </div>
    </div>
  );
}
